<template>
  <el-container style="height: 100vh;">
    <el-main>
      <router-view />
    </el-main>
  </el-container>
</template>

<script>
export default {
  name: "BlankLayout"
}
</script>